function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3 8.12c0-1.13 0-1.694.178-2.187a3 3 0 01.747-1.15c.378-.362.894-.591 1.926-1.05L9.4 2.155c.957-.425 1.435-.638 1.933-.722a4 4 0 011.332 0c.498.084.976.297 1.933.722l3.55 1.578c1.032.459 1.548.688 1.926 1.05a3 3 0 01.747 1.15C21 6.426 21 6.99 21 8.119v5.456c0 1.252 0 1.878-.173 2.447a4 4 0 01-.737 1.377c-.377.459-.898.806-1.94 1.5l-3.487 2.326c-.963.641-1.444.962-1.964 1.087-.46.11-.938.11-1.398 0-.52-.125-1.001-.446-1.964-1.087L5.85 18.9c-1.042-.695-1.563-1.042-1.94-1.501a4.001 4.001 0 01-.737-1.378C3 15.454 3 14.828 3 13.575V8.119z",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgShield = function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    stroke: "#9193A9"
  }, props), _ref);
};

export default SvgShield;